import { Outlet } from 'react-router-dom'
import { PageHeader } from '../../../components/ui/PageHeader'

/** Отдельный раздел «Заявки на производство» (`/production-requests`). */
export function ProductionRequestsLayout() {
  return (
    <div>
      <PageHeader
        title="Заявки на производство"
        lead="Учёт заявок: клиент из CRM, номенклатура из продукции СУП, даты по позициям и расчёт комплектации по спецификации."
      />
      <div className="mt-5">
        <Outlet />
      </div>
    </div>
  )
}
